<template>
    <div class="info-list">
        <Header/>
        <div class="blank20"/>
        <div class="main-page-content contain-left-right">
            <div class="left-content">
                <div>
                    <a href="/searchScore"><div class="btn-item">成绩查询</div></a>
                    <div class="btn-item select">证书查询</div>
                </div>
                <div class="blank40"/>
                <div class="blank20"/>
                <div v-if="Object.hasOwnProperty.call(cerObj,'certificate_no')" class="zs_block">
                    <img :src="Number(cerObj.type)===0?'':''">
                    <img class="person_header" :src="cerObj.avatar">
                    <div class="row name">{{account}}</div>
                    <div class="row card_num">{{card_num}}</div>
                    <div class="row card_no">{{cerObj.certificate_no}}</div>
                    <div class="row time">{{cerObj.certificate_date}}</div>
                </div>
                <div v-if="!Object.hasOwnProperty.call(cerObj,'certificate_no')" class="cx_list">
                    <form class="search-form">
                        <li class="t">证书编号：</li>
                        <li class="in">
                            <input v-model="no" type="text" name="sfzh">
                        </li>
                        <li class="t">姓名：</li>
                        <li class="in">
                            <input v-model="account" type="text" name="title">
                        </li>
                        <li class="t">身份证号：</li>
                        <li class="in">
                            <input v-model="card_num" type="text" name="sfzh">
                        </li>
                        <li class="button">
                            <div class="btn default" @click="submit"> 查询 </div>
                        </li>
                    </form>
                </div>
            </div>
            <RightContent />
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
export default {
    data() {
        return {
            account:'',
            card_num:'',
            no:'',
            cerObj:{
            },
        }
    },
    filter:{
        formatZS(type){
            if(Number(type) === 0){
                return '';
            }else{
                return '';
            }
        }
    },
    components:{
    },
    created() {
    },
    methods: {
        async submit(){
            if(this.no === ''){
                this.$toast('请输入证书编号');
                return false;
            }
            else if(this.account === ''){
                this.$toast('请输入姓名');
                return false;
            }else if(this.card_num === ''){
                this.$toast('请输入身份证号码');
                return false;
            }
            const params = {
                certificate_no:this.no,
                name:this.account,
                card_num:this.card_num
            }
            try {
                const res = await this.$http.get('/api/exam/getScore',params);
                if(res){
                    res.card_num = this.card_num;
                    res.name = this.name;
                    this.cerObj = res;
                }
            } catch (error) {
                this.$toast(error.message||'请求失败');
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.zs_block{
    width:700px;
    height:495px;
    margin: auto;
    text-align: center;
    position: relative;
    .row{
        position: absolute;
        left: 135px;
        font-size: 11px;
        width: 150px;
    }
    .person_header{
        position: absolute;
        width: 65px;
        height: 89px;
        left: 145px;
        top: 135px;
    }
    .name{
        top:253px
    }
    .card_num{
        top:330px;
    }
    .card_no{
        top:369px;
    }
    .time{
        top:414px;
    }
    img{
        width:700px;
        height:495px;
    }
}
.cx_list {
    width: 300px;
    padding: 20px;
    margin: 40px auto;
    background: #f2f9fd;
    border-radius: 10px;
    border: 1px solid #cdcac4;
}
.cx_list li{ padding:10px 5px; font-size:16px; height:40px; line-height:40px;}
.cx_list li.t{ text-align:right; width:80px; color:#333;display: inline-block;
    vertical-align: middle;}
.cx_list li.in{ width:200px; text-align:left;display: inline-block;
    vertical-align: middle;}
.cx_list li.in input{ border:1px solid #999; height:30px; width:200px; line-height:30px; border-radius:5px;}
.cx_list li .btn{ padding:10px 20px; background:#1c4585; color:#fff; margin:0 auto; border-radius:5px; border:0px; font-size:16px;}
.cx_list li.button{ width:300px; text-align:center;}
.btn-item{
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    height: 49px;
    line-height: 47px;
    font-size: 18px;
    color: #333;
    margin-right: 20px;
    padding: 0 20px;
    font-weight: 400;
}
.btn{
    width: 32px;
    height: 22px;
    line-height: 20px;
    cursor: pointer;
}
.select{
    font-weight: bold;
    background: #224899;
    color: #fff;
    border-radius: 30px;
}
</style>
